export const PLATOONS_COMPANY_OPTIONS = Array.from({ length: 12 }, (_, idx) => idx + 1);
